<template>
  <section class="section-one section-one__second">
    <div class="section-one__title">FOCUS LIVE MARKET</div>
    <div class="section-one--container">
      <div class="content-container container__box">
        <span class="title-bold-one">Veicoli comparati</span>
        <span class="price-bold">{{ focus.veicoli_totali }}</span>
        <span class="qrt-icon-target">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-crosshair" viewBox="0 0 16 16">
  <path d="M8.5.5a.5.5 0 0 0-1 0v.518A7 7 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7 7 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7 7 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7 7 0 0 0 8.5 1.018zm-6.48 7A6 6 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6 6 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6 6 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6 6 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
</svg>
        </span>
      </div>
      <div class="content-container container__five">
        <div class="title">Comparazione qualitativa</div>
        <div class="text-two">
          L'analisi qualitativa ottimizza i risultati sulla base di parametri più vicini al veicolo
          oggetto della quotazione (chilometraggio, anno di immatricolazione, prezzo...).
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LivemarketDataFocus',
  props: {
    focus: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.section-one.section-one__second {
  padding: 70px 0px 34px;
}
.section-one {
  display: flex;
  padding: 65px 0px 58px;
  margin: 0px 100px;
  border-top: 2px solid #d20a11;
  position: relative;
}
.section-one__title {
  color: #ffffff;
  background-color: #d20a11;
  padding: 0px 25px;
  height: 33px;
  position: absolute;
  top: 0;
  left: 38.5%;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  line-height: 56px;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-one--container {
  display: flex;
  width: 100%;
  align-items: center;
  max-width: 830px;
  margin: auto;
}
.container__box {
  position: relative;
  width: 152px;
  height: 110px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 15px;
}
.content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title-bold-one {
  font-size: 0.875rem;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
}
.container__box .price-bold {
  margin-top: 0px;
}
.price-bold {
  font-size: 47px;
  line-height: 62px;
  color: #d20a11;
  font-weight: bold;
}
.container__box .qrt-icon-target {
  font-size: 32px;
  position: absolute;
  bottom: -15px;
  background-color: rgb(204, 204, 204);
  padding: 5px;
  border-radius: 5px;
}
.container__five {
  flex: 1;
  display: block;
}
.container__five .title {
  margin-bottom: 10px;
}
.title {
  color: #d20a11;
  font-size: 21px;
  line-height: 28px;
  font-weight: bold;
}
.text-two {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 5px;
}
@media (max-width: 768px) {
    .section-one.section-one__second {
        padding: 57px 0px 34px;
    }
    .section-one, .section-five {
        padding: 40px 0px;
        margin: 0px 17px;
    }
    .section-one--container {
        flex-direction: column;
    }
    .section-one.section-one__second .section-one--container {
        flex-direction: column-reverse;
    }
    .container__box {
        width: 100%;
        margin-right: 0px;
        margin-top: 25px;
    }

}
@media (max-width: 600px) {
    .section-one__title {
        left: 34.5%;
    }
}
@media (max-width: 414px) {
    .section-one__title {
        left: 16.5%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataFocus.vue